import React, { useContext, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  CircularProgress,
  IconButton,
  Snackbar,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { PreferTimeContext } from '../../../services/prefer-time/prefer-time.context';
import { Loading } from '../../../components/utility/loading';
import { TimeTable } from './table';

const useStyles = makeStyles((theme) => {
  return {
    submitBox: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      marginBottom: 16,
    },
    wrapper: {
      marginBottom: 0,
      position: 'relative',
      marginRight: 16,
      marginTop: 16,
    },
    timeTableWrapper: {
      marginBottom: 0,
      position: 'relative',
    },
    buttonProgress: {
      color: '#000',
      position: 'absolute',
      top: '13%',
      left: '40%',
    },
    button: {
      marginRight: 16,
      marginTop: 16,
    },
  };
});

export const TimeTableComponent = () => {
  const classes = useStyles();
  const history = useHistory();
  const { functions, states } = useContext(PreferTimeContext);
  const { savePreferTime, getPreferTime, clearPreferTime } = functions;
  const {
    error,
    toggleSnackBar,
    setToggleSnackBar,
    isLoading,
    refreshing,
    timeZone,
  } = states;

  useEffect(() => {
    getPreferTime();
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      setToggleSnackBar(false);
    }
    setToggleSnackBar(false);
  };

  return (
    <div>
      <div className={classes.timeTableWrapper}>
        <TimeTable />
        {refreshing && <Loading />}
      </div>

      <Link to='/account/timezone'>
        {timeZone ? `Your current time zone is ${timeZone}` : `Please set your default time zone`}
      </Link>

      <div className={classes.submitBox}>
        <div className={classes.wrapper}>
          <Button
            size='small'
            variant='contained'
            color='primary'
            onClick={savePreferTime}
            disabled={isLoading}
          >
            Save Changes
          </Button>
          {isLoading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>

        <Button
          className={classes.button}
          type='submit'
          size='small'
          variant='outlined'
          disabled={isLoading}
          onClick={() => getPreferTime('refreshing')}
        >
          Undo
        </Button>

        <Button
          className={classes.button}
          type='submit'
          size='small'
          variant='outlined'
          onClick={clearPreferTime}
          disabled={isLoading}
        >
          Clear
        </Button>

        <Button
          className={classes.button}
          type='submit'
          size='small'
          variant='outlined'
          onClick={() => history.push('/meetings')}
          disabled={isLoading}
        >
          Discard Changes
        </Button>
      </div>
      {error && (
        <Typography color='error' variant='caption'>
          {error}
        </Typography>
      )}
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={toggleSnackBar}
        autoHideDuration={2000}
        onClose={handleClose}
        TransitionComponent='alpha'
        message='prefer time has been saved.'
        action={
          <IconButton
            size='small'
            aria-label='close'
            color='inherit'
            onClick={handleClose}
          >
            <CloseIcon fontSize='small' />
          </IconButton>
        }
      />
    </div>
  );
};
